import type { Favorites, NoItems, Recents, SubRowsHash } from "ls/common/table-schemas";
import type { CreateOrganizationWorkspaces, NoOrganizationWorkspaces, NoSharedWithMeWorkspaces, SuggestedWorkspaces } from "../workspaces/utils";
import type { FilesystemJs, FolderRowJs, OrganizationJs, RecentJs, ShortcutJs } from "@/generated/models";
import { FilesystemJsSchema } from "ls/common/entity-schemas";
import { FavoritesIdSchema, FavoritesSchema, RecentsIdSchema, RecentsSchema } from "ls/common/table-schemas";
import * as v from "valibot";

const hasItemsSchema = v.object({
  items: v.array(v.any()),
});
export const hasItems = (row: unknown) => v.is(hasItemsSchema, row);

const JoinedWorkspacesIdSchema = v.literal("joined");
const joinedWorkspacesSchema = v.object({
  id: JoinedWorkspacesIdSchema,
  name: v.string(),
  items: v.array(FilesystemJsSchema),
});
export type JoinedWorkspaces = v.InferOutput<typeof joinedWorkspacesSchema>;
export const isJoinedWorkspaces = (row: unknown) => v.is(joinedWorkspacesSchema, row);

const JoinableWorkspacesIdSchema = v.literal("joinable");
const joinableWorkspacesSchema = v.object({
  id: JoinableWorkspacesIdSchema,
  name: v.string(),
  items: v.array(FilesystemJsSchema),
});
export type JoinableWorkspaces = v.InferOutput<typeof joinableWorkspacesSchema>;
export const isJoinableWorkspaces = (row: unknown) => v.is(joinableWorkspacesSchema, row);

const ArchivedWorkspacesIdSchema = v.literal("archived");
const archivedWorkspacesSchema = v.object({
  id: ArchivedWorkspacesIdSchema,
  name: v.string(),
  items: v.array(FilesystemJsSchema),
});
export type ArchivedWorkspaces = v.InferOutput<typeof archivedWorkspacesSchema>;
export const isArchivedWorkspaces = (row: unknown) => v.is(archivedWorkspacesSchema, row);
export const BrowseWorkspacesGroupSchema = v.union([JoinedWorkspacesIdSchema, JoinableWorkspacesIdSchema, ArchivedWorkspacesIdSchema]);
export type BrowseWorkspacesGroup = v.InferOutput<typeof BrowseWorkspacesGroupSchema>;

const customGroups = v.union([FavoritesSchema, joinedWorkspacesSchema, joinableWorkspacesSchema, archivedWorkspacesSchema, RecentsSchema]);

export type RowData = OrganizationJs
  | FilesystemJs
  | FolderRowJs
  | ShortcutJs
  | RecentJs
  | Recents
  | Favorites
  | NoItems
  | CreateOrganizationWorkspaces
  | NoSharedWithMeWorkspaces
  | SuggestedWorkspaces
  | NoOrganizationWorkspaces
  | SubRowsHash
  | JoinedWorkspaces
  | JoinableWorkspaces
  | ArchivedWorkspaces;

export const isCustomGroup = (input: unknown) => v.is(customGroups, input);

export const NavigationTreeGroupsSchema = v.union([FavoritesIdSchema, RecentsIdSchema]);

export type RootNavigationGroup
  = "root-navigation-me"
    | "root-navigation-recents"
    | "root-navigation-favorites"
    | "root-navigation-private-workspace"
    | "root-navigation-organizations"
    | "root-navigation-shared-assets";

export type NavigationGroup = "recents" | "favorites" | "private-workspace" | "organizations" | "shared-assets";
